/** Who may do what on the Vendors place - mirrored from the server, and the reason Add is offered to
 * fewer roles than the route table's upload roles.
 *
 * `api/sources.py` `MAY_DECLARE` (Admin, Approver) guards every write to the register: an account's
 * dates narrow what the census expects of every meter on it, so recording one is a statement about
 * completeness. A Contributor may enter data elsewhere but would be refused here, so the place offers
 * Add to these two only (design rule 6: no control that predictably fails). Requesting data from a
 * supplier is collection work (`api/suppliers.py` `MAY_COLLECT`).
 */
import { whoCan } from "../../shell/whoCan";

/** One home for who: `shell/whoCan.ts`, held to the server's routes by a test. */
export const MAY_RECORD: readonly string[] = whoCan("addVendor");
export const MAY_COLLECT: readonly string[] = whoCan("requestSupplierData");
